import styled from 'styled-components';

import Link from '../../UI/Link/Link';
import variables from '../../../styles/variables';

export const ToolBar = styled.div`
  margin: 0 auto 20px;
  width: 100%;
  max-width: ${variables.defaultWidth}px;
  min-height: 45px;

  @media screen and (max-width: 767px) {
    margin: 0 auto 10px;
  }
`;

export const Container = styled.div`
  display: flex;
  max-width: 1280px;
  margin: 0 2.5rem;
  padding: 8px 0;
  border-top: 1px solid #979797;
  border-bottom: 1px solid #979797;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 1024px) {
    margin: 0 1.25rem;
  }
`;

export const Phone = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 20px;
  padding-right: 20px;
  width: 33.3%;
  height: 100%;
  max-height: 30px;
  border-right: 2px dotted rgba(151, 151, 151, 0.3);
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const Content = styled.p<{defaultMsg?: boolean;}>`
  margin-bottom: 0;
  font-size: 14px;
  line-height: 17px;
  ${(props) => props.defaultMsg
    ? 'color: rgba(51, 51, 51, 0.5);'
    : 'color: rgba(51, 51, 51, 1);'};
  @media screen and (max-width: 1100px) {
    font-size: 12px;
  }
`;

export const Remove = styled.button`
  -webkit-appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const CloseIcon = styled.span`
  width: 12px;
  position: relative;
  height: 12px;
  .bm-cross-left {
    position: absolute;
    width: 2px;
    height: 12px;
    transform: rotate(45deg);
    background-color: rgba(51, 51, 51, 0.5);
  }
  .bm-cross-right {
    position: absolute;
    width: 2px;
    height: 12px;
    transform: rotate(-45deg);
    background-color: rgba(51, 51, 51, 0.5);
  }
`;

export const MobileView = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: flex;
  }
  p {
    font-size: 12px;
  }
`;

export const CompareContainer = styled.div`
  display: flex;
  width: 45%;
  align-items: center;
  justify-content: space-evenly;
  @media screen and (max-width: 1024px) {
    width: 30%;
    justify-content: space-between;
    padding-right: 10px;
  }
  @media screen and (max-width: 767px) {
    width: 60%;
    justify-content: flex-end;
    padding-right: 0;
  }
`;

export const RemoveAllPhonesButton = styled.button`
  font-size: 12px;
  line-height: 15px;
  border: none;
  background: none;
  border-bottom: 1px solid ${variables.colorBlack};
  -webkit-appearance: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  &.compareLink {
    color: ${variables.colorRed};
  }
  &:hover {
    border-bottom: 1px solid transparent;
  }
  &.phone-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    text-decoration: none;
    @media screen and (max-width: 320px) {
      font-size: 17px;
    }
    @media screen and (min-width: 560px) and (max-width: 639px) {
      font-size: 16px;
    }
    @media screen and (min-width: 769px) and (max-width: 1099px) {
      font-size: 17px;
    }
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const CompareButton = styled(Link)`
  font-size: 12px;
  color: ${variables.defaultBackground};
  cursor: pointer;
  height: 30px;
  width: 135px;
  border-radius: 15px;
  background-color: ${variables.colorRed};
  align-items: center;
  display: flex;
  justify-content: center;
  text-decoration: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  margin-bottom: 0;
  &:hover {
    background-color: #c70000;
  }
  @media screen and (max-width: 1024px) {
    margin: 0;
    width: 90px;
  }
  @media screen and (max-width: 767px) {
    width: 96px;
    margin-left: 50px;
  }
  @media screen and (max-width: 375px) {
    margin-left: 25px;
  }
`;
